import { FileType as importFileType, FileTypeName, fileTypeMap, fileTypes } from '@cambridgeassessment/lib-ee-commons';

export type FileType = importFileType;

const COMPONENT_FILE_TYPES = [
  FileTypeName.VIDEO,
  FileTypeName.AUDIO,
  FileTypeName.DATA,
  FileTypeName.PRESENTATION,
  FileTypeName.IMAGE,
  FileTypeName.WEB,
  FileTypeName.DOCUMENT,
  FileTypeName.COMPRESSION,
];

export const componentFileTypesOnly = COMPONENT_FILE_TYPES.map((fileType) => fileTypeMap[fileType]);

export default fileTypes;
